import { oneOfType, node, element, string, elementType } from 'prop-types'
import { useHits } from 'react-instantsearch'

const CustomHits = ({
  CustomComponent,
  SearchItem,
  testId,
  ...passedProps
}) => {
  const { hits } = useHits()

  return (
    <CustomComponent
      hits={hits}
      SearchItem={SearchItem}
      testId={testId}
      {...passedProps}
    />
  )
}

CustomHits.propTypes = {
  SearchItem: oneOfType([node, element, elementType]),
  CustomComponent: oneOfType([node, element, elementType]).isRequired,
  testId: string,
}

export default CustomHits
